/**
 * 简易 SEO 工具
 *
 * 背景：本项目是 Vue SPA，服务器返回的 HTML 是空壳（只有 <div id="app"></div>），
 *       搜索引擎抓取并渲染 JS 后才能识别页面主题。这里统一维护
 *       <title> / meta description / meta keywords / link canonical，
 *       让百度等搜索引擎在渲染后能拿到正确的标题与页面描述，并识别规范地址。
 *
 * 规范域名（canonical）：与 SSL 证书 CN、百度搜索资源平台站点、sitemap.xml、
 * 主动推送使用的域名保持一致，避免同站多域名造成重复内容、权重分散。
 * 如需切换为不带 www 的域名，只改这一处（同时要同步服务器 301 与百度站点验证）。
 */

export const SITE_ORIGIN = 'https://www.3v3v.cn'
export const SITE_NAME = '欢乐购商城'
export const DEFAULT_TITLE = '欢乐购商城 - 品质好物 · 拼单更优惠'
export const DEFAULT_DESCRIPTION =
  '欢乐购商城（3v3v.cn）——品质好物、拼单更优惠，支持微信 / 支付宝 / 余额支付，正品保障、极速发货。'
export const DEFAULT_KEYWORDS = '欢乐购商城,3v3v,网上购物,拼单,拼团,优惠商品,手机商城'

/**
 * 创建或更新 <meta>
 */
function upsertMeta (attr, key, content) {
  if (!content) return
  let el = document.head.querySelector('meta[' + attr + '="' + key + '"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

/**
 * 设置 / 更新 canonical（规范地址）
 * @param {string} pathOrUrl 站内路径（/prodetail/12）或完整 URL
 */
export function setCanonical (pathOrUrl) {
  const value = pathOrUrl || '/'
  const href = /^https?:\/\//i.test(value) ? value : SITE_ORIGIN + value
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * 设置 robots 指令（如 index,follow / noindex,follow），避免无需收录的页面被抓取
 * @param {string} content
 */
export function setMetaRobots (content) {
  if (!content) return
  upsertMeta('name', 'robots', content)
}

/**
 * 设置页面 SEO 信息（未传的字段使用站点默认值）
 * @param {object} options { title, description, keywords, path, siteName }
 */
export function setSeo ({ title, description, keywords, path, siteName } = {}) {
  const name = siteName || SITE_NAME
  document.title = title ? (title + ' - ' + name) : DEFAULT_TITLE
  upsertMeta('name', 'description', description || DEFAULT_DESCRIPTION)
  upsertMeta('name', 'keywords', keywords || DEFAULT_KEYWORDS)
  setCanonical(path || (window.location.pathname + window.location.search))
}
